import React from 'react'
import Navbar from '../../components/shared/Navbar/Navbar'
import Footer from '../../components/shared/Footer/Footer'
import ServicesHero from '../../components/pages/Services/ServicesHero/ServicesHero'
import ServicesCapabilities from '../../components/pages/Services/ServicesCapabilites/ServicesCapabilities'
import ExtraOrdinary from '../../components/pages/Services/ExtraOrdinary/ExtraOrdinary'
import { ServicesPageProvider } from '../../context/ServicesPageContext'

const Services = () => {
  return (
    <ServicesPageProvider>
      <div>
        <Navbar />
        <ServicesHero />
        <ServicesCapabilities />
        <ExtraOrdinary />
        <Footer />
      </div>
    </ServicesPageProvider>
  )
}

export default Services
